import { memo, useEffect } from 'react';
import { PRICE_UPDATE_FREQUENCY } from '../../constants';
import { usePricesStore, useProductPriceSubSetup } from '../../hooks/useProductPricesSub';
import { useProducts } from '../../hooks/useProducts';

const PriceSub = memo(({ productId }: { productId: string }) => {
  useProductPriceSubSetup(productId);
  return null;
});

export const PricesSub = ({ interval = PRICE_UPDATE_FREQUENCY }) => {
  const { data: products } = useProducts();
  const { setPricesByProductId } = usePricesStore();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setPricesByProductId();
    }, interval);

    setPricesByProductId();

    return () => clearInterval(intervalId);
  }, [interval, setPricesByProductId]);

  return products?.map((x) => <PriceSub key={x.id} productId={x.id} />);
};
